import React from 'react';
export function FinalCTA() {
  return <section className="bg-gradient-to-b from-[#0a0a0a] via-[#1a0000] to-[#0a0a0a] py-[44px] px-5 text-center" data-id="element-57">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-58">
        <h2 className="font-montserrat font-black text-[clamp(1.8rem,5vw,3.2rem)] text-brand-white uppercase leading-[1.1] mb-[14px]" data-id="element-59">
          El Próximo Encuentro
          <br data-id="element-60" />
          Puede Ser{' '}
          <span className="text-brand-red" data-id="element-61">Completamente Diferente</span>
        </h2>
        <p className="text-[1.05rem] text-[#7a7570] max-w-[540px] mx-auto mb-[18px] leading-[1.55]" data-id="element-62">
          Tenés el sistema. Tenés la garantía. La única pregunta es: ¿cuánto
          tiempo más querés seguir esperando?
        </p>

        <a href="#comprar" className="block w-full max-w-[500px] mx-auto bg-gradient-to-br from-brand-red to-brand-red-dark text-white font-montserrat font-black text-[clamp(0.95rem,2.5vw,1.2rem)] uppercase tracking-[1.5px] py-5 px-6 rounded-lg border-none cursor-pointer transition-all duration-300 shadow-[0_8px_30px_rgba(204,0,0,0.45)] relative overflow-hidden hover:-translate-y-[3px] hover:shadow-[0_14px_45px_rgba(204,0,0,0.65)] before:content-[''] before:absolute before:top-0 before:-left-full before:w-full before:h-full before:bg-gradient-to-r before:from-transparent before:via-[rgba(255,255,255,0.12)] before:to-transparent before:transition-[left] before:duration-500 hover:before:left-full" data-id="element-63">
          🔥 Acceder al Sistema Ahora
        </a>

        <p className="mt-[18px] text-[0.78rem] text-[#333] font-montserrat tracking-[1px] uppercase" data-id="element-64">
          🔒 Pago Seguro &nbsp;·&nbsp; Acceso Inmediato &nbsp;·&nbsp; Garantía
          30 Días
        </p>
      </div>
    </section>;
}